module.exports = __webpack_public_path__ + "static/media/mnp.7ed6bc0a.jpg";